import Link from "next/link";
import Innerhtml from "./Innerhtml"; // tumhara already existing component
import WsrvImage from "./WsrvImage";

export default function SeriesCard({ series, centers }) {
  const isOnline =
    series?.linkedProduct?.category === "5b47f7ef1e899567332d1d0a";

  return (
    <div className="rounded-2xl p-6 shadow-lg border-2 border-gray-200 h-full flex flex-col">
      {/* Header */}

      <div className="text-center">
        <h3 className="xl:text-[22.66px] text-base font-bold text-[#000000] mb-1">
          {series?.name}
        </h3>
        <p className="xl:text-[11.33px] text-[10px] text-[#666] mb-4">
          {series?.eduStandard?.name}
        </p>

        {/* Price Box */}
        <div
          className={`mb-2 ${
            isOnline ? "bg-[#FFF7EB]" : "bg-[#FFD338]"
          } py-3 px-3 rounded-md flex justify-center items-center gap-1`}
        >
          <span className="lg:text-[28.99px]  text-xl font-medium text-gray-900">
            <sup className="lg:text-[16.19px] text-sm mx-1">₹</sup>
            {series?.cost}
          </span>
          <span className="text-sm lg:text-[17.81px] font-[400] text-gray-700">
            {isOnline ? "Online Test Series" : "Offline Test Series"}
          </span>
        </div>
      </div>

      {/* Description */}
      <div className="flex-grow mb-6">
        <div className="h-72 overflow-y-auto pr-2 custom-scroll px-3">
          <ul className="space-y-3">
            <li className="flex items-start space-x-2">
              <Innerhtml data={series?.desci} />
            </li>
          </ul>
        </div>
      </div>

      {/* Footer (Buttons/Links) */}
      <div className="mt-auto h-[160px] overflow-y-auto">
        {isOnline ? (
          <>
            {/* Buy Now */}
            <Link
              href={`/courses/details/${series?.linkedProduct.uri}`}
              className="w-full bg-yellow-400 inline-block lg:text-[18.19px] text-sm hover:bg-yellow-500 text-gray-900 text-center py-3 px-4 rounded-lg font-bold mb-4 transition-colors"
            >
              Buy Now
            </Link>

            {/* Download App */}
            <Link
              href="https://play.google.com/store/apps/details?id=in.clclive.app"
              target="_blank" rel="noopener noreferrer"
              className="w-full bg-yellow-400 inline-block lg:text-[16.19px] text-sm text-center hover:bg-yellow-500 text-gray-900 py-3 px-4 rounded-lg font-medium mb-4 transition-colors"
            >
              Download <span className="font-[800]">CLC Live App</span>
            </Link>

            {/* Store Badges */}
            <div className="flex justify-center md:space-x-6 space-x-2">
              <Link
                href="https://play.google.com/store/apps/details?id=in.clclive.app"
                target="_blank" rel="noopener noreferrer"
              >
                <WsrvImage
                  src="/badges/google-play.svg"
                  alt="Get it on Google Play"
                  width={135}
                  height={40}
                  widths={[135, 270]}
                  sizes="135px"
                  className="h-8 w-auto cursor-pointer hover:opacity-80 transition-opacity"
                />
              </Link>
              <Link
                href="https://apps.apple.com/in/app/clc-live-for-iit-jee-and-neet/id6737020863"
                target="_blank" rel="noopener noreferrer"
              >
                <WsrvImage
                  src="/badges/app-store.svg"
                  alt="Download on the App Store"
                  width={120}
                  height={40}
                  widths={[120, 240]}
                  sizes="120px"
                  className="h-8 w-auto cursor-pointer hover:opacity-80 transition-opacity"
                />
              </Link>
            </div>
          </>
        ) : (
          <>
            {centers && (
              <div className="text-center">
                <div className="rounded-lg p-3">
                  <div className="text-sm bg-[#EAEAEA] py-3 px-4 rounded-lg w-full text-[16.91px] font-medium text-gray-900 mb-2">
                    {centers?.key}
                  </div>
                </div>
                {centers?.data?.length > 0 && (
                  <div>
                    {centers.data.map((center, ind) => (
                      <span key={ind} className="text-[14.57px] text-[#000000] leading-relaxed">
                        {center.title}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
